import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService, Permission } from './auth.service';
import { CognitoService } from './cognito.service';

export const authGuard: CanActivateFn = async (route, state) => {
  const router = inject(Router);
  const cognitoService = inject(CognitoService);
  try {
    const user = await cognitoService.isAuthenticated();
    if (user) {
      return true; // User is authenticated
    }
  } catch (error) {
    console.error('User not authenticated:', error);
  }

  // Redirect to login if not authenticated
  router.navigate(['login'], { queryParams: { returnUrl: state.url } });

  return true;
};

export const canViewGuard: CanActivateFn = (route, state) => {
  const perms = inject(AuthService);
  const router = inject(Router);
  const entity = route.data?.['entity'] as string;
  const flag = (route.data?.['flag'] as keyof Permission) || 'canview';
  // console.log('canViewGuard:', { entity, flag });
  if (entity && perms.has(entity, flag)) return true; // User is  authorized

  router.navigate(['unauthorized']);
  return false;
};
